export enum DealThesisSidebarTabs {
  Inputs,
}
